// VIIMII STUDIO - Mock data (frontend-only phase)
// NOTE: All data below is MOCKED. In the backend phase this will be replaced
// with real API data + admin-managed content.

export const BRAND = {
  name: "VIIMII STUDIO",
  fullName: "Viimii's Nails & Eyelash Studio",
  tagline: "Nail Studio & Hair Spa",
  instagram: "https://www.instagram.com/_.viimii._/?hl=en",
  instagramHandle: "@_.viimii._",
  whatsapp: "917045435493",
  phone: "+91 70454 35493",
  email: "hello@viimiistudio.com",
  address: "Shop No. 17, Rodium Xenon Apartment, Ground Floor, Shankar Lane, Kandivali West, Mumbai 400067",
  mapUrl: "https://maps.app.goo.gl/yqyad6NBYmV2hNmv9",
  mapEmbed: "https://www.google.com/maps?q=Viimii's+Nails+%26+Eyelash+Studio+Kandivali+West+Mumbai&output=embed",
  bookOnline: "https://luzo.app/partners/viimiis-nail-eyelash-studio-mumbai-kandivali-west-mumbai",
  hours: "11:00 AM - 8:30 PM, All Days",
  rating: "5.0",
  est: "2020",
};

export const NAIL_IMAGES = [
  "https://images.pexels.com/photos/34835304/pexels-photo-34835304.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1610992015762-45dca7fa3a85?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.unsplash.com/photo-1607779097040-26e80aa78e66?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/7066298/pexels-photo-7066298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/34997574/pexels-photo-34997574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/22668317/pexels-photo-22668317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1519014816548-bf5fe059798b?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/6135680/pexels-photo-6135680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/34997566/pexels-photo-34997566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1604902396830-aca29e19b067?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/4677845/pexels-photo-4677845.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const INTERIOR = {
  salon: "https://images.unsplash.com/photo-1773904215697-e6c21fc27ac2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  salon2: "https://images.pexels.com/photos/7195809/pexels-photo-7195809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  hairspa: "https://images.unsplash.com/photo-1544717304-a2db4a7b16ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  artist: "https://images.pexels.com/photos/5178007/pexels-photo-5178007.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=800",
  artist2: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  pedicure: "https://images.pexels.com/photos/34373403/pexels-photo-34373403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const MARQUEE_WORDS = [
  "Nail Therapy", "Eyelash Extensions", "Mani-Pedi", "Nail Art", "Wax Therapy",
  "Luxe Facials", "Korean Glass Skin", "Hair Spa", "K-Beauty Scalp", "Massage Therapy",
];

export const STATS = [
  { value: "5+", label: "Years Experience" },
  { value: "3K+", label: "Happy Clients" },
  { value: "5.0\u2605", label: "Google Rating" },
  { value: "5\u2605", label: "Rated Studio" },
];

export const ABOUT_FEATURES = [
  { title: "Precision Hygiene", desc: "Advanced sterilization standards with meticulous care at every appointment." },
  { title: "Signature Artistry", desc: "Luxury nail & hair creations tailored with premium products and expert craft." },
  { title: "Premium Products", desc: "Only the finest international brands for long-lasting, salon-quality results." },
  { title: "Trend-Forward", desc: "Always ahead of the curve with the latest nail & hair trends globally." },
];

export const WHY_US = [
  { n: "01", title: "Signature Studio", desc: "A refined space built for luxury nail artistry and relaxing hair spa rituals." },
  { n: "02", title: "Expert Artists", desc: "Skilled artists trained in the latest global nail & hair techniques." },
  { n: "03", title: "Premium Products", desc: "Only certified international brands - safe, long-lasting and vibrant." },
  { n: "04", title: "Safe & Hygienic", desc: "Medical-grade sterilization protocols for every client, every time." },
  { n: "05", title: "Bespoke Experience", desc: "Each service is personalized to your vision, style and occasion." },
  { n: "06", title: "Punctual & Professional", desc: "We respect your time - appointments always on schedule." },
  { n: "07", title: "Trend-Forward Designs", desc: "From classic elegance to avant-garde nail art - we master every style." },
  { n: "08", title: "4.9\u2605 Loved", desc: "Adored by clients who keep coming back for the VIIMII touch." },
];

export const THERAPY_IMG = {
  nails: "/services/nail-therapy.jpg",
  lashes: "https://images.unsplash.com/photo-1589710751893-f9a6770ad71b?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  lashes2: "https://images.unsplash.com/photo-1639629509821-c54cdd984227?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  brow: "https://images.unsplash.com/photo-1735151225764-eac694642dbf?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  manipedi: "https://images.pexels.com/photos/34373403/pexels-photo-34373403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  wax: "https://images.unsplash.com/photo-1700760933574-9f0f4ea9aa3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  skin: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  skin2: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  hair: "https://images.unsplash.com/photo-1544717304-a2db4a7b16ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  massage: "https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  massage2: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
};

// Service therapies - sourced directly from the VIIMII STUDIO menu.
export const SERVICES = [
  { id: 1, cat: "The Nail Therapy", title: "The Nail Therapy", desc: "Gel polish on natural nails, semi & acrylic/gel extensions, overlays and custom nail art.", price: "\u20b9350", note: "Starting From", img: THERAPY_IMG.nails },
  { id: 2, cat: "The Eye Therapy", title: "The Eye Therapy", desc: "Classic, hybrid & volume eyelash extensions, lash lifting, tinting and brow shaping.", price: "\u20b91,500", note: "Starting From", img: THERAPY_IMG.lashes },
  { id: 3, cat: "Mani-Pedi", title: "The Luxe Mani-Pedi", desc: "Coffee, candle, donut and ice-cream jelly manicures & pedicures for glowing hands and feet.", price: "\u20b9650", note: "Starting From", img: THERAPY_IMG.manipedi },
  { id: 4, cat: "The Wax Therapy", title: "The Wax Therapy", desc: "Honey wax, Rica wax and roll-on / peel-off waxing for smooth, cared-for skin.", price: "\u20b970", note: "Starting From", img: THERAPY_IMG.wax },
  { id: 5, cat: "The Skin Therapy", title: "The Luxe Skin Therapy", desc: "Clean-ups, detan, advance facials plus Korean glass-skin & collagen treatments.", price: "\u20b9600", note: "Starting From", img: THERAPY_IMG.skin },
  { id: 6, cat: "The Hair Menu", title: "The Luxe Hair Menu", desc: "Hot hair champi, hair wash, luxury hair spas and K-beauty 14-step scalp rituals.", price: "\u20b9300", note: "Starting From", img: THERAPY_IMG.hair },
  { id: 7, cat: "Massage", title: "The Massage Therapy", desc: "Foot, half-leg, back and head & shoulder massages to melt away every bit of stress.", price: "\u20b9150", note: "Starting From", img: THERAPY_IMG.massage },
];

// Full menu - every service & sub-service, transcribed from the VIIMII STUDIO menu.
export const PRICING = [
  { cat: "The Nail Therapy", note: "Nail art per finger charged extra.", groups: [
    { sub: "Gel Polish on Natural Nails", items: [
      ["Fingers", "\u20b9350"], ["Toes", "\u20b9350"], ["Overlays", "\u20b9800"], ["Overlays Refill", "\u20b9800"],
    ]},
    { sub: "Extension", items: [
      ["Semi Extension", "\u20b9600"], ["Acrylic / Gel Extensions", "\u20b91,000"],
      ["Gelx / Soft Gel Extensions", "\u20b91,000"], ["Refill", "\u20b9800"],
    ]},
    { sub: "Removal", items: [
      ["Semi Extension", "\u20b9250"], ["Gel Polish", "\u20b9150"], ["Extension / Overlays", "\u20b9400"],
    ]},
  ]},
  { cat: "The Eye Therapy", groups: [
    { sub: "Eyelash Extensions", items: [
      ["Classic Extension", "\u20b92,700"], ["Hybrid Extension", "\u20b93,700"], ["Volume Extension", "\u20b94,700"],
      ["Refill (15-20 days)", "\u20b91,350"], ["Removal", "\u20b91,000"],
    ]},
    { sub: "Natural Eyelash Lifting & Tinting", items: [
      ["Lash Lifting", "\u20b91,800"], ["Lash Lifting + Tinting", "\u20b92,000"],
    ]},
    { sub: "Brow Tinting", items: [
      ["Eyebrow Shaping + Tinting", "\u20b91,500"],
    ]},
  ]},
  { cat: "The Luxe Mani-Pedi Experience", groups: [
    { sub: "Coffee Pedicure", desc: "Helps remove tan, revealing brighter, smoother & more even-toned feet.", items: [
      ["Manicure", "\u20b9650"], ["Pedicure", "\u20b9700"], ["Mani-Pedi Combo", "\u20b91,250"],
    ]},
    { sub: "Candle Pedicure", desc: "Boosts hydration and leaves your feet feeling silky smooth.", items: [
      ["Manicure", "\u20b9900"], ["Pedicure", "\u20b91,000"], ["Mani-Pedi Combo", "\u20b91,800"],
    ]},
    { sub: "Donut Pedicure", desc: "Helps restore a natural, healthy-looking glow to your feet.", items: [
      ["Manicure", "\u20b91,000"], ["Pedicure", "\u20b91,200"], ["Mani-Pedi Combo", "\u20b92,000"],
    ]},
    { sub: "Ice Cream Jelly Pedicure", desc: "Removes rigid tan, deeply hydrates & leaves glowing, baby-soft feet.", items: [
      ["Manicure", "\u20b91,450"], ["Pedicure", "\u20b91,700"], ["Mani-Pedi Combo", "\u20b93,000"],
    ]},
  ]},
  { cat: "The Wax Therapy", groups: [
    { sub: "Honey Wax", items: [
      ["Underarms", "\u20b970"], ["Full Hands", "\u20b9300"], ["Full Legs", "\u20b9400"], ["Half Legs", "\u20b9250"],
      ["Stomach", "\u20b9350"], ["Back", "\u20b9490"], ["FH + FL + UA", "\u20b9750"],
    ]},
    { sub: "Rica Wax", items: [
      ["Underarms", "\u20b9200"], ["Full Hands", "\u20b9500"], ["Full Legs", "\u20b9650"], ["Half Legs", "\u20b9370"],
      ["Stomach", "\u20b9470"], ["Back", "\u20b9550"], ["UA + FH", "\u20b9700"], ["FH + FL + UA", "\u20b91,000"],
    ]},
    { sub: "Roll On / Peel Off", items: [
      ["Underarms", "\u20b9200"], ["Full Hands", "\u20b9500"], ["Full Legs", "\u20b9650"], ["Stomach", "\u20b9620"],
      ["Back", "\u20b9770"], ["UA + FH", "\u20b9750"], ["FH + FL + UA", "\u20b91,400"],
      ["Chin / Sidelock / Forehead", "\u20b9100"], ["Upper Lips", "\u20b970"], ["Neck", "\u20b9200"], ["Full Face", "\u20b9400"],
    ]},
  ]},
  { cat: "The Luxe Skin Therapy", groups: [
    { sub: "Basic", items: [
      ["Clean Up", "\u20b9600"], ["Detan Clean Up", "\u20b9800"], ["Facial", "\u20b91,000"], ["Detan Facial", "\u20b91,100"],
      ["Advance Bright-Up Facial", "\u20b91,300"], ["Anti-Ageing", "\u20b91,600"],
      ["Acne Treatment Facial", "\u20b91,500"], ["Skin Whitening Facial", "\u20b91,600"],
    ]},
    { sub: "Advance", items: [
      ["O3 Clean Up", "\u20b91,100"], ["O3 Detan Clean Up", "\u20b91,200"], ["O3 Acne Clean Up", "\u20b91,200"],
      ["Advance Clean Up", "\u20b91,300"], ["Shine & Glow Facial", "\u20b91,800"], ["Youthful Facial", "\u20b92,000"],
      ["Korean Glass Skin Hydration Facial", "\u20b92,500"], ["Anti-Ageing", "\u20b92,600"],
      ["O3 Seaweed Acne Treatment Facial", "\u20b92,200"], ["Collagen Facial", "\u20b93,000"],
      ["Power Brightening Facial", "\u20b93,500"],
    ]},
  ]},
  { cat: "The Luxe Hair Menu", groups: [
    { sub: "Hot Hair Champi / Hair Wash", items: [
      ["Basic Hair Oil Massage", "\u20b9350"], ["Ayurvedic Hair Oil Massage", "\u20b9500"],
      ["Normal Hair Wash", "\u20b9300"], ["Sulphate Free Hair Wash", "\u20b9500"],
    ]},
    { sub: "Hair Spa", items: [
      ["Lo'real Hair Spa", "\u20b91,200"], ["Hot Oil Hair Spa", "\u20b91,500"], ["Keratin Hair Spa", "\u20b91,500"],
      ["Biotin Hair Spa", "\u20b92,000"], ["Shea Butter Hair Spa", "\u20b92,500"], ["Ginger Hair Spa", "\u20b94,000"],
    ]},
    { sub: "Hair Scalp Treatment - K-Beauty 14-Step Ritual", items: [
      ["K-Beauty Anti-Dandruff", "\u20b96,999"], ["K-Beauty Hairfall", "\u20b96,999"],
      ["K-Beauty Dry Scalp", "\u20b96,999"], ["K-Beauty Oily Scalp", "\u20b96,999"],
    ]},
  ]},
  { cat: "The Massage Therapy", groups: [
    { sub: "Foot Massage", items: [
      ["10 minutes", "\u20b9150"], ["15 minutes", "\u20b9200"], ["20 minutes", "\u20b9300"], ["30 minutes", "\u20b9400"],
    ]},
    { sub: "Half Leg", items: [
      ["10 minutes", "\u20b9200"], ["15 minutes", "\u20b9250"], ["20 minutes", "\u20b9400"], ["30 minutes", "\u20b9500"],
    ]},
    { sub: "Back", items: [
      ["10 minutes", "\u20b9250"], ["15 minutes", "\u20b9300"], ["20 minutes", "\u20b9400"], ["30 minutes", "\u20b9600"],
    ]},
    { sub: "Head & Shoulder Massage", items: [
      ["20 minutes", "\u20b9450"], ["30 minutes", "\u20b9600"],
    ]},
  ]},
];

export const STEPS = [
  { n: 1, title: "Book Online", desc: "Choose your service and time slot - book in under 60 seconds via our form or WhatsApp." },
  { n: 2, title: "Consult & Customize", desc: "Our expert artists understand your goals and recommend the perfect look." },
  { n: 3, title: "Luxury Treatment", desc: "Relax in our premium studio while our specialists craft your look with care." },
  { n: 4, title: "Walk Out Flawless", desc: "Leave with stunning results and confidence that turns heads wherever you go." },
];

export const FAQS = [
  ["How long do nail extensions last?", "Nail extensions typically last 3-4 weeks with proper care. We recommend a refill every 2-3 weeks to maintain the perfect look."],
  ["What services does VIIMII STUDIO offer?", "We're a full nail, lash, skin & hair spa studio - nail therapy, eyelash extensions & brows, luxe mani-pedis, waxing, facials, hair spa and relaxing massage therapy."],
  ["Do you offer Korean beauty treatments?", "Yes! We're known for our Korean Glass Skin Hydration Facial and our signature K-Beauty 14-step scalp rituals for dandruff, hairfall, dry and oily scalp."],
  ["How do I book an appointment?", "Book instantly using the form on our website, tap 'Book Now' anywhere on the page, or message us on WhatsApp. We confirm your slot within minutes."],
  ["How long does a typical appointment take?", "Gel polish takes 45-60 mins, extensions 90-120 mins, and facials / hair spa around 60-90 mins depending on the treatment. We never rush perfection."],
  ["Are your products safe for sensitive skin & nails?", "Absolutely. We use only certified premium brands, safe for all skin, nail and hair types. Our artists assess your needs before recommending a service."],
];

export const TESTIMONIALS = [
  { id: "t1", name: "Ananya Sharma", text: "Very neat work. Loved the service and result. The hair spa left my hair so soft. Value for money!" },
  { id: "t2", name: "Riya Kapoor", text: "Wonderful experience at VIIMII. Attention to detail was amazing. My nails look exactly how I wanted." },
  { id: "t3", name: "Sneha Menon", text: "The team is patient and friendly. The studio ambience is gorgeous and so clean." },
  { id: "t4", name: "Priya Nair", text: "Amazing experience with incredible attention to detail. My nails look absolutely stunning." },
  { id: "t5", name: "Tanvi Desai", text: "French tip nails were perfect. Clean, uniform and beautifully done. Highly professional." },
  { id: "t6", name: "Meera Iyer", text: "First time trying the hair spa + cat eye nails combo - did not disappoint. Loved it!" },
  { id: "t7", name: "Kavya Reddy", text: "Clean, shiny and long-lasting nails exactly how I wanted. Will definitely be back." },
  { id: "t8", name: "Isha Verma", text: "Great service, professional staff and a wide choice of colors. Totally worth it!" },
];

// Reels: image posters used in frontend mock. In backend phase these become
// admin-uploaded short videos (autoplay, muted, loop).
export const REELS = [
  { id: 1, poster: NAIL_IMAGES[0], caption: "Chrome Glam" },
  { id: 2, poster: NAIL_IMAGES[5], caption: "Silver Ombre" },
  { id: 3, poster: NAIL_IMAGES[2], caption: "French Luxe" },
  { id: 4, poster: INTERIOR.hairspa, caption: "Hair Spa Ritual" },
  { id: 5, poster: NAIL_IMAGES[9], caption: "Nude Elegance" },
  { id: 6, poster: NAIL_IMAGES[10], caption: "Bridal Set" },
  { id: 7, poster: NAIL_IMAGES[3], caption: "Art Play" },
  { id: 8, poster: NAIL_IMAGES[12], caption: "Extension Perfection" },
];

export const AWARDS = [
  { title: "Excellence in Nail Artistry", sub: "Signature Best Nail Art" },
  { title: "Creative Design Recognition", sub: "Bridal Nail & Hair Artistry" },
  { title: "Technical Excellence", sub: "Advanced Innovation & Precision" },
  { title: "Client Love Award", sub: "Highest Rated Studio Experience" },
];

// Default per-sub-service durations (minutes). Admin can override in Scheduling.
export const DEFAULT_SUBDURATIONS = {
  "The Nail Therapy|Gel Polish on Natural Nails|Fingers": 40,
  "The Nail Therapy|Gel Polish on Natural Nails|Toes": 40,
  "The Nail Therapy|Gel Polish on Natural Nails|Overlays": 90,
  "The Nail Therapy|Gel Polish on Natural Nails|Overlays Refill": 120,
  "The Nail Therapy|Extension|Semi Extension": 60,
  "The Nail Therapy|Extension|Acrylic / Gel Extensions": 120,
  "The Nail Therapy|Extension|Gelx / Soft Gel Extensions": 120,
  "The Nail Therapy|Extension|Refill": 120,
  "The Nail Therapy|Removal|Semi Extension": 30,
  "The Nail Therapy|Removal|Gel Polish": 30,
  "The Nail Therapy|Removal|Extension / Overlays": 30,
  "The Eye Therapy|Eyelash Extensions|Classic Extension": 120,
  "The Eye Therapy|Eyelash Extensions|Hybrid Extension": 150,
  "The Eye Therapy|Eyelash Extensions|Volume Extension": 150,
  "The Eye Therapy|Eyelash Extensions|Refill (15-20 days)": 90,
  "The Eye Therapy|Eyelash Extensions|Removal": 30,
  "The Eye Therapy|Natural Eyelash Lifting & Tinting|Lash Lifting": 45,
  "The Eye Therapy|Natural Eyelash Lifting & Tinting|Lash Lifting + Tinting": 60,
  "The Eye Therapy|Brow Tinting|Eyebrow Shaping + Tinting": 30,
  "The Luxe Mani-Pedi Experience|Coffee Pedicure|Manicure": 45,
  "The Luxe Mani-Pedi Experience|Coffee Pedicure|Pedicure": 60,
  "The Luxe Mani-Pedi Experience|Coffee Pedicure|Mani-Pedi Combo": 90,
  "The Luxe Mani-Pedi Experience|Candle Pedicure|Manicure": 45,
  "The Luxe Mani-Pedi Experience|Candle Pedicure|Pedicure": 60,
  "The Luxe Mani-Pedi Experience|Candle Pedicure|Mani-Pedi Combo": 90,
  "The Luxe Mani-Pedi Experience|Donut Pedicure|Manicure": 45,
  "The Luxe Mani-Pedi Experience|Donut Pedicure|Pedicure": 60,
  "The Luxe Mani-Pedi Experience|Donut Pedicure|Mani-Pedi Combo": 90,
  "The Luxe Mani-Pedi Experience|Ice Cream Jelly Pedicure|Manicure": 60,
  "The Luxe Mani-Pedi Experience|Ice Cream Jelly Pedicure|Pedicure": 90,
  "The Luxe Mani-Pedi Experience|Ice Cream Jelly Pedicure|Mani-Pedi Combo": 120,
};

export function defaultDuration(cat, sub, name) {
  const key = `${cat}|${sub}|${name}`;
  if (DEFAULT_SUBDURATIONS[key] != null) return DEFAULT_SUBDURATIONS[key];
  const m = String(name).match(/(\d+)\s*min/i);
  if (m) return parseInt(m[1], 10);
  return 45;
}
